import React, { useEffect, useState, useContext } from "react"
import Grid from "@material-ui/core/Grid"
import ActivityFeedCard from "../components/ActivityFeedCard"
import ExportsOptionCard from "../components/ExportsOptionCard"
import { fetchExports } from "../api/apiCalls.js"
import { HistoryContext } from "../contexts/HistoryContext"
import { UserContext } from "../contexts/UserContext"
import { MessagingContext } from "../contexts/MessagingContext"

const ExportsPage = () => {
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [options, setOptions] = useState([])
  const { errors, successMessages } = useContext(MessagingContext)

  const { fetchHistory, history, historyLoading, historyError } = useContext(
    HistoryContext
  )
  const { user } = useContext(UserContext)

  const exportHistory = history.filter(
    (item) =>
      item.activity_type_id === 6 ||
      item.activity_type_id === 12 ||
      item.activity_type_id === 13 ||
      item.activity_type_id === 9 ||
      item.activity_type_id === 7 ||
      (item.activity_type_id === 3 && item.context === "megafile") ||
      (item.activity_type_id === 2 &&
        (item.context === "megafile" || item.context === "purchpost"))
  )

  useEffect(() => {
    fetchExports()
      .then(({ options }) => {
        setLoading(false)
        setOptions(options)
      })
      .catch((error) => {
        setLoading(false)
        setError(error)
      })
  }, [])

  useEffect(() => {
    console.log(errors)
  }, [errors])

  useEffect(() => {
    console.log(successMessages)
  }, [successMessages])

  const reload = () => {
    fetchHistory(user)
  }

  return (
    <Grid container>
      <Grid md={6}>
        <Grid md={10}>
          <ExportsOptionCard options={options} loading={loading} error={error} />
        </Grid>
      </Grid>
      <Grid md={6}>
        <Grid md={10}>
          <ActivityFeedCard
            title="Export Activity"
            activities={exportHistory}
            loading={historyLoading}
            error={historyError}
            refreshHistory={reload}
          />
        </Grid>
      </Grid>
    </Grid>
  )
}

export default ExportsPage
